export enum PhoneTypeValues {
  MOBILE = 'mobile',
  HOME = 'home',
  UNKNOWN = 'unknown',
  OTHER = 'work',
}
